export const FLAG_GETTING_BUSSES_MAINTENANCE_STAY =
  'FLAG_GETTING_BUSSES_MAINTENANCE_STAY';
export const GET_BUSSES_MAINTENANCE_STAY = 'GET_BUSSES_MAINTENANCE_STAY';
export const CLEAR_BUSSES_MAINTENANCE_STAY = 'CLEAR_BUSSES_MAINTENANCE_STAY';
export const FLAG_BUS_MAINTENANCE_STAY = 'FLAG_BUS_MAINTENANCE_STAY';
export const GET_BUS_MAINTENANCE_STAY = 'GET_BUS_MAINTENANCE_STAY';
export const CLEAR_BUS_MAINTENANCE_STAY = 'CLEAR_BUS_MAINTENANCE_STAY';

export const GET_ITINERARY_ARRIVALS = 'GET_ITINERARY_ARRIVALS';
export const FLAG_GETTING_ITINERARY_ARRIVALS =
  'FLAG_GETTING_ITINERARY_ARRIVALS';
export const CLEAR_ITINERARY_ARRIVALS = 'CLEAR_ITINERARY_ARRIVALS';

export const GET_BUS_MAINTENANCE_STAY_DEMAND =
  'GET_BUS_MAINTENANCE_STAY_DEMAND';
export const FLAG_GETTING_BUS_MAINTENANCE_STAY_DEMAND =
  'FLAG_GETTING_BUS_MAINTENANCE_STAY_DEMAND';
export const CLEAR_BUS_MAINTENANCE_STAY_DEMAND =
  'CLEAR_BUS_MAINTENANCE_STAY_DEMAND';

export const GET_EXTENDED_BUS_MAINTENANCE_STAYS =
  'GET_EXTENDED_BUS_MAINTENANCE_STAYS';
export const FLAG_GETTING_EXTENDED_BUS_MAINTENANCE_STAYS =
  'FLAG_GETTING_EXTENDED_BUS_MAINTENANCE_STAYS';
export const CLEAR_EXTENDED_BUS_MAINTENANCE_STAYS =
  'FLAG_GETTING_EXTENDED_BUS_MAINTENANCE_STAYS';
